'use strict';

var get = function get(obj, props, defVal) {
    var path = Array.isArray(props) ? props : props.split('.');
    var val = path.reduce(function (subObj, prop) {
        return subObj && subObj[prop] !== undefined ? subObj[prop] : null;
    }, obj);
    return val !== null ? val : defVal;
};

var pick = function pick(obj, props) {
    var propsArr = Array.isArray(props) ? props : [props];
    return propsArr.reduce(function (subObj, prop) {
        var _Object$assign;

        var val = get(obj, prop);
        return val !== undefined ? Object.assign(subObj, (_Object$assign = {}, _Object$assign[prop] = val, _Object$assign)) : subObj;
    }, {});
};

var setAttributes = function setAttributes(node, attributes) {
    return node && attributes && Object.keys(attributes).forEach(function (attr) {
        return node.setAttribute(attr, attributes[attr]);
    });
};

var setStyle = function setStyle(node, styleProperties) {
    return node && styleProperties && Object.assign(node.style, styleProperties);
};

var cssStringToObject = function cssStringToObject(styleStr) {
    if (!styleStr || !styleStr.split) {
        return {};
    }

    return styleStr.split(';').reduce(function (ruleMap, ruleString) {
        var rulePair = ruleString.split(':');
        if (rulePair[0] && rulePair[1]) {
            ruleMap[rulePair[0].trim()] = rulePair[1].trim();
        }

        return ruleMap;
    }, {});
};

module.exports = {
    get: get,
    pick: pick,
    setAttributes: setAttributes,
    setStyle: setStyle,
    cssStringToObject: cssStringToObject
};
//# sourceMappingURL=layoutUtils.js.map